import { ConsentFlow } from '@/ordering/consentFlow'

/**
 * Whether the platform (not the clinician) collects the comparator's consent
 * to test (GEN-5654). Mirrors provider-api; no clinician choice in any mode.
 *
 * - A  `PRACTITIONER_MEDIATED`    -> never
 * - AB `PRACTITIONER_MEDIATED_AB` -> only for comparators added after submission
 * - B  `PRIMARY`                  -> always
 */
export function resolveComparatorPlatformCollects(flow: string | null | undefined, addedAfterSubmit: boolean): boolean {
  const normalized = (flow ?? '').trim()
  if (normalized === ConsentFlow.Primary) return true
  if (normalized === ConsentFlow.PractitionerMediatedAb) return addedAfterSubmit
  return false
}

interface ContactChannels {
  email?: string | null
  phone?: string | null
}

export interface OrderGuardianContactSource {
  guardianContact?: (ContactChannels & { contactNotAvailable?: boolean | null }) | null
  primaryConsent?: { familyMember?: ContactChannels | null } | null
}

const hasChannel = (c: ContactChannels | null | undefined): boolean => Boolean(c?.email?.trim() || c?.phone?.trim())

/**
 * Whether the order already carries a guardian email/phone. Mirrors provider-api:
 * `guardianContact.contactNotAvailable=true` ignores the guardian slot and falls
 * back to `primaryConsent.familyMember`. The same fallback applies when the
 * guardian slot has no channel, because the guardian contact is persisted on the
 * family member and does not always round-trip on `guardianContact`.
 */
export function orderHasGuardianContact(order: OrderGuardianContactSource | null | undefined): boolean {
  const guardian = order?.guardianContact
  if (guardian && guardian.contactNotAvailable !== true && hasChannel(guardian)) return true
  return hasChannel(order?.primaryConsent?.familyMember)
}
